import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function DeschideProblem() {
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-1119">
      <div className="max-w-4xl mx-auto px-6" data-id="element-1120">
        <SectionHeading title="Simți că dai mult, dar nu primești la fel?" data-id="element-1121" />

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-brand-cream rounded-3xl p-8 md:p-12 shadow-sm border border-brand-text/5 mb-12" data-id="element-1122">
          <div className="space-y-6 text-lg text-brand-text/80 leading-relaxed" data-id="element-1123">
            <p className="font-bold text-xl text-brand-text" data-id="element-1124">
              Oferi mult la muncă, în relații, pentru ceilalți. Dar când vine
              vorba de tine, simți că viața nu îți oferă la fel.
            </p>
            <p data-id="element-1125">
              Poate ai impresia că trăiești pe jumătate. Că lipsește ceva, dar
              nu știi exact ce. Banii vin greu, relațiile sunt tensionate,
              energia e la pământ și liniștea interioară pare un lux pe care nu
              ți-l poți permite. Te simți obosită emoțional și mental, și cauți
              pace, dar nu știi cum să o obții.
            </p>
            <p data-id="element-1126">
              Cu fiecare zi în care continui să dai fără să primești, te
              golești. Frustrările se adâncesc. Corpul simte, relațiile simt,
              contul din bancă simte. Și cel mai greu lucru e că nu e vorba de
              cât muncești. E vorba de un blocaj mai adânc: nu îți permiți să
              primești. Și până nu rezolvi asta, nimic din exterior nu se va
              schimba.
            </p>

            <div className="mt-8 p-6 bg-brand-gold/5 border-l-4 border-brand-gold rounded-r-xl" data-id="element-1127">
              <p className="font-medium text-brand-text italic" data-id="element-1128">
                Cursul Deschide-ți Larg Brațele către Abundență te ghidează să
                înțelegi ce e abundența cu adevărat, să deblochezi capacitatea
                de a primi, să creezi echilibru între a da și a primi și să
                aduci abundența în viața ta pe toate planurile. Include o
                meditație care îți aduce instant pacea minții și unelte practice
                pe care le poți aplica zilnic. Printre ele, propoziția win-win,
                o tehnică care l-a ajutat pe Adrian să semneze contracte cu
                venituri de peste 100.000 de euro în 3 ani.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-1129">
          <CTAButton data-id="element-1130" />
        </motion.div>
      </div>
    </section>;
}